import * as React from 'react';
import { Popover } from 'antd';
import { FC, useMemo } from 'react';
import { LocationCard } from './LocationCard';
import {
	getProtectedImageUriForBuyer,
	getProtectedImageUriForSupplier,
} from '../../../utils/FileAccessUtils';
import { connect } from 'react-redux';
import { AddressDisplay } from '../../address_display/AddressDisplay';
import { nullSafeGet } from '../../../utils/DataAccessUtils';

interface LocationNameComponentProps {
	location: any;
	mode?: 'card' | 'inline' | 'container' | 'avatar';
	secondaryField?: string;
	showImages?: boolean;
	size?: 'default' | 'large';
	allowHover?: boolean;
	popoverMode?: 'simple' | 'full';
	placement?: string;
	userType?: String;
	underline?: boolean;
}

const LocationName: FC<LocationNameComponentProps> = ({
	location,
	mode = 'card',
	secondaryField = 'email',
	showImages = true,
	size = 'default',
	allowHover = true,
	popoverMode = 'full',
	placement = 'leftTop',
	userType = 'buyer',
	underline = false,
}) => {
	//const subTitle = nullSafeGet(secondaryField, contact);
	const onClick = (e) => {
		e.preventDefault();
		e.stopPropagation();
	};

	const getProtectedImageMethod = useMemo(
		() =>
			userType === 'supplier' ? getProtectedImageUriForSupplier : getProtectedImageUriForBuyer,
		[userType]
	);

	// Callers routinely pass `nullSafeGet('location', entity)`, which is undefined whenever the
	// entity was fetched through a path that doesn't hydrate its location. Every dereference below
	// (`location.images`, `location.name`) is unguarded, so render nothing rather than crash the
	// whole page — a missing location is a data gap, not a reason to take the route down.
	if (!location) {
		return null;
	}

	const displayImageURL =
		location.images &&
		location.images[0] &&
		getProtectedImageMethod(
			location.images[0].split('/')[0],
			location.images[0].split('/')[1],
			'auto',
			120
		);

	const isVertical = true;

	const popoverContent = (
		<LocationCard
			location={location}
			name={location.name}
			subTitle={''}
			showImages={true}
			size={size}
			mode={popoverMode}
			isVertical={isVertical}
			userType={userType as 'buyer' | 'supplier'}
		/>
	);
	const element =
		mode === 'card' ? (
			<span>
				<LocationCard
					location={location}
					name={location.name}
					subTitle={''}
					showImages={true}
					size={size}
					mode={popoverMode}
					isVertical={isVertical}
					userType={userType as 'buyer' | 'supplier'}
				/>
			</span>
		) : mode === 'inline' ? (
			<div className="flex flex-col">
				<span>{location.name}</span>
				<span
					style={{
						color: 'rgba(0,0,0,0.45)',
						fontSize: 12,
					}}
				>
					{nullSafeGet('locationType.name', location)} {nullSafeGet('storeId', location)}
				</span>
				<AddressDisplay
					style={{
						color: 'rgba(0,0,0,0.45)',
						fontSize: 12,
					}}
					address={nullSafeGet('buyerFacility.primaryAddress', location)}
				/>
			</div>
		) : mode === 'container' ? (
			<span
				className={`inline-block max-w-[60ch] cursor-pointer truncate align-middle ${
					underline ? 'underline' : ''
				}`}
			>
				{location.name}
			</span>
		) : mode === 'avatar' ? (
			<span>
				<LocationCard
					location={location}
					name={location.name}
					subTitle={''}
					showImages={true}
					size={size}
					mode={popoverMode}
					isVertical={isVertical}
					userType={userType as 'buyer' | 'supplier'}
				/>
			</span>
		) : (
			<span></span>
		);

	return allowHover ? (
		<Popover placement={placement} content={popoverContent}>
			{element}
		</Popover>
	) : (
		element
	);
};

const LocationNameComponent = connect()(LocationName);

export default connect(
	(state) => ({
		userType: state.session.userType,
	}),
	(dispatch, ownProps) => ({})
)(LocationNameComponent);
